import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ServicePathProviderService } from '@blk/cwp-ng-framework';
import { MarketViewsConstants, MarketViewsUtil } from '@ddt-web/common';
import { APPLICATION_NAME_TOKEN, ApplicationName } from '@ddt-web/config';
import { ApplicationNames, WebUserDataConstants } from '@ddt-web/domain';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { MarketViewConfig, MarketViewConfigResponse, MarketViewData } from '../models/market-view-config.interface';

@Injectable({
	providedIn: 'root'
})
export class MarketViewConfigService {
	private configObject: { [key: string]: MarketViewConfig };
	private apiGatewayPath: string;
	private configPath: string;

	constructor(
		private http: HttpClient,
		private servicePathProvider: ServicePathProviderService,
		@Inject(APPLICATION_NAME_TOKEN) private applicationName: ApplicationName
	) {
		this.apiGatewayPath = this.servicePathProvider.getServicePath('api-gateway');
		if (this.applicationName === ApplicationNames.MODELS_BROWSE) {
			this.configPath = WebUserDataConstants.MODEL_EVALUATOR_MARKET_VIEW;
		} else if (this.applicationName === ApplicationNames.MODELS_EXPERIENCE) {
			this.configPath = WebUserDataConstants.MODELS_EXPERIENCE_MARKET_VIEW;
		}
	}

	public fetchConfig(key: string): Observable<MarketViewConfig> {
		if (!this.configObject) {
			return this.fetchConfigFromApi().pipe(map(configs => configs[key]));
		} else {
			return of(this.configObject[key]);
		}
	}

	private fetchConfigFromApi(): Observable<{ [key: string]: MarketViewConfig }> {
		return this.configPath ? this.http.get<MarketViewConfigResponse>(this.apiGatewayPath + this.configPath).pipe(
			map(csvResponse => {
				const result: { [key: string]: MarketViewConfig } = {};
				(csvResponse?.resultMap?.REPORT ?? []).forEach(type => {
					const headers = MarketViewsUtil.getHeaderCells('DEFAULT', MarketViewsConstants.MARKET_MOVES_HEADER_DCR_KEYS);
					// CSV response from wds, actual data is on index 1, index 0 is meta data
					const rows = (type.data?.[1] ?? []).map(
						row => (
							{
								view: row['View'],
								assetClassName: row['Asset Class Name'],
								description: row['Description'],
								isHeader: row['Asset Class Name'] ? false : true
							} as MarketViewData)
					);
					result[type.variant] = {
						headers: headers,
						rows: rows
					};
				});
				this.configObject = result;
				return result;
			}),
			catchError(error => {
				console.error('Market View config error:', error);
				return of({});
			})
		) : of({});
	}
}
